import { config } from 'configs'
import { useAuthSelector } from 'store/authSlice/authReducer'

const useRoles = () => {
  const { user, userRoles } = useAuthSelector()

  const isDonor = user?.roles?.includes(config?.roles?.donor)
  const isPresenter = user?.roles?.includes(config?.roles?.presenter)
  const isSubscriber = user?.roles?.includes(config?.roles?.subscriber)
  const isBusiness = user?.roles?.includes(config?.roles?.business)
  const isAdmin = user?.roles?.includes(config?.roles?.admin)

  const hasAnyOrganizationRole = userRoles?.length > 0

  return {
    isDonor,
    isPresenter,
    isSubscriber,
    isBusiness,
    isAdmin,
    hasAnyOrganizationRole,
  }
}

export { useRoles }
